import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue';
import { LevelModel, Permission } from '@/types';
import { UsersIcon, PhoneIcon } from '@heroicons/vue/solid';
import { CheckCircleIcon, XCircleIcon, PencilAltIcon } from '@heroicons/vue/outline';
import UiAuditInfo from '@/components/UiAuditInfo.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'LevelListItem',
  props: {
    modelValue: {
        type: Object as PropType<LevelModel>,
        required: true,
    },
},
  emits: ['activate', 'inactivate'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const handleActivateClick = () => emit('activate', props.modelValue);
const handleInactivateClick = () => emit('inactivate', props.modelValue);

const __returned__ = { props, emit, handleActivateClick, handleInactivateClick, get Permission() { return Permission }, get UsersIcon() { return UsersIcon }, get PhoneIcon() { return PhoneIcon }, get CheckCircleIcon() { return CheckCircleIcon }, get XCircleIcon() { return XCircleIcon }, get PencilAltIcon() { return PencilAltIcon }, UiAuditInfo }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})